import type { ModelState } from '../types/techniques/ModelState'
import type { Level } from './Level'

export type ErreurState<TLevel extends Level = Level> = {
  $estErreur?: boolean
  $messageErreur?: string | null
  $level?: TLevel | null
  $origine?: string | null
}

export type Erreur<TModel, TLevel extends Level = Level> = ModelState<TModel, ErreurState<TLevel>>

export function InitErreurDefault<TModel, TLevel extends Level = Level>() {
  return {
    $estErreur: false,
    $level: null,
    $messageErreur: null,
    $origine: null,
  } as Erreur<TModel, TLevel>
}
